"use client"
import { createSvgIcon, useTheme } from "@mui/material"
import type { IconProps } from "../types"
import { getPath } from "../utils"

const ArrowDown = createSvgIcon(
  <path d="M11.9991 14.7019L6.69141 9.39422L7.39911 8.68652L11.9991 13.2865L16.5991 8.68652L17.3068 9.39422L11.9991 14.7019Z" />,
  "ArrowDown",
)

const ArrowDownIcon = (props: IconProps) => {
  const { fill, sx, ...rest } = props
  const theme = useTheme()
  const _fill =
    (fill && getPath(theme.palette, fill)) || theme.palette.text.primary
  return <ArrowDown sx={{ fill: _fill, ...sx }} {...rest} />
}
export default ArrowDownIcon
